import {Alert, Form} from "react-bootstrap";
import PropTypes from "prop-types";
import {NumericFormat as NumberFormat} from "react-number-format";
import {LabelFor} from "./LabelFor.jsx";


const InputNumeric = (props) => {

    const fieldClassName = props?.value !== undefined ? 'form-control text-end' : 'form-control text-end text-secondary';

    return (
        <Form.Group readOnly={props.readOnly}
                    className={props.className}>
            <LabelFor label={props.label} id={props.id || props.name || props.ariaLabel || props.label}
                      hideLabel={props.hideLabel}  tooltipText={props.tooltipText}/>
            <NumberFormat
                id={props.id || props.name || props.ariaLabel || props.label}
                aria-label={props.label || props.title || 'wpisz wartość'}
                title={props.title}
                readOnly={props.readOnly}
                value={props.value}
                placeholder={props.placeholder}
                onValueChange={(e) => props.setter && props.setter(props.name, e.value)}
                className={fieldClassName}
                displayType={"input"}
                height={props.height}
                size={props.size}
                disabled={props.disabled}
                thousandSeparator={" "}
                decimalSeparator={"."}
                decimalScale={props.decimal}
                isAllowed={(values) => {
                    const {formattedValue, floatValue} = values;
                    return formattedValue === "" || floatValue <= (props.limit || 100000000000);
                }}
                onChange={(e) => props.onChange({
                    ...e,
                    'target': {...e['target'], [`value`]: +e.target.value.replace(/ /g, '')}
                })}
                fixedDecimalScale={true}
                allowNegative={true}
                // allowEmptyFormatting={false}
                defaultValue={props.initial}
                // renderText={(value, props) => <div {...props}>{value}</div>}
            />

            {props.errorText && (
                <Alert className={"p-1 w-100"} variant={"danger"}>
                    <div className={"ms-1"}> {props.errorText}</div>
                </Alert>
            )}
        </Form.Group>
    );
};


InputNumeric.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    decimal: PropTypes.number,
    disabled: PropTypes.bool,
    negative: PropTypes.bool,
    limit: PropTypes.number,
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    ariaLabel: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    initial: PropTypes.number,
    errorText: PropTypes.string,
    setter: PropTypes.func,
    hideLabel: PropTypes.bool,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltipText: PropTypes.string,

};

export default InputNumeric;
